//import { AuthService } from './auth.service';
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { ToastController } from 'ionic-angular';


//import { Router } from '@angular/router';

@Injectable()
export class MyHttpLogInterceptor implements HttpInterceptor {
  constructor(
    // private router: Router,
    private authService: AuthService, private toastController: ToastController
  ) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    /*if (this.authService.userData) {
      alert("VALOR " + this.authService.userData.id)
      request = request.clone({ headers: request.headers.set('token', this.authService.userData.id) });
    }*/
    //alert("Entra")*/
    console.log("por aca pasa")
  
    if (this.authService.userData) {
      console.log( "TOKEN ", this.authService.userData.id)
      request = request.clone({
        setHeaders: {
          token: this.authService.userData.id,
          Authorization: this.authService.userData.id,
          'Access-Control-Allow-Origin': "*",
          'Content-Type':"application/json",
          'Accept': '*/*'
          
        }
      });
    }
    else{
      request = request.clone({
        setHeaders: {
         // token: this.authService.userData.id,
          //Authorization: this.authService.userData.id,
          'Access-Control-Allow-Origin': "*",
          'Content-Type':"application/json",
          'Accept': '*/*'
          
          
        }
      });
    }
    return next
      .handle(request)
      .do((ev: HttpEvent<any>) => {
        if (ev instanceof HttpResponse) {
          //console.log('processing response', ev);
        }
      }, (err: any) => {
        console.log(err)
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            //this.auth.collectFailedRequest(request);
          //  this.presentToast("Su sesión ha caducado.")
            this.authService.logout()
            //this.router.navigate(['/login']);

          }
        }
      });
  }

  presentToast(msg) {
    let toast = this.toastController.create({
      message: msg,
      duration: 3000,
      position: 'top'
    });

    toast.onDidDismiss(() => {
      console.log('Dismissed toast');
    });

    toast.present();
  }
}


// WEBPACK FOOTER //
// ./src/services/auth/http.interceptor.ts